import Accordion from '../../generic/Accordion';
import Card from '../../generic/Card/Card';

import OrganizationSearch from './OrganizationSearch';

const OrganizationCard = () => {
  return (
    <Card isFullWidth padding="medium">
      <Card.Content>
        <Accordion id="organization-info" isInitiallyOpen={false}>
          <Accordion.Target>Organization Info</Accordion.Target>
          <Accordion.Body>
            <OrganizationSearch />
          </Accordion.Body>
        </Accordion>
      </Card.Content>
    </Card>
  );
};

export default OrganizationCard;
